module.exports = __webpack_public_path__ + "static/media/RidesThree.d18ee40b.jpg";